import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

const rateCardsSlice = createSlice({
  name: "rateCards",
  initialState: {
    rateCards: [],
    isRateCardLoading: false,
    isRateCardError: false,
  },
  reducers: {
    setRateCards: (
      state,
      action: PayloadAction<{
        rateCards?: { data: RateCard[] };
      }>,
    ) => {
      const { rateCards } = action.payload;
      state.rateCards = rateCards?.data || [];
    },
    setRateCardsLoadingStatus: (state, action) => {
      const { loading, error } = action.payload;
      state.isRateCardLoading = loading;
      state.isRateCardError = error;
    },
  },
});

export const { setRateCards, setRateCardsLoadingStatus } =
  rateCardsSlice.actions;
export const rateCardsReducer = rateCardsSlice.reducer;
